'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const utils_uniqueId = require('../../../utils/uniqueId.cjs.js');

const _interopDefault = e => e && e.__esModule ? e : { default: e };

const React__default = /*#__PURE__*/_interopDefault(React);

const root = "_root_19o5x_1";
const input = "_input_19o5x_8";
const styles = {
	root: root,
	input: input
};

const colorVariations = {
  gray: {
    base: {
      borderColor: theme_Colors.Colors.GrayWarm7
    },
    check: {
      borderColor: theme_Colors.Colors.Blue3
    },
    hover: {
      borderColor: theme_Colors.Colors.Blue3
    },
    focus: {
      backgroundColor: theme_Colors.Colors.Blue3,
      borderColor: theme_Colors.Colors.Blue3
    }
  },
  white: {
    base: {
      borderColor: theme_Colors.Colors.PrimeWhite
    },
    check: {
      borderColor: theme_Colors.Colors.PrimeWhite
    },
    hover: {
      borderColor: theme_Colors.Colors.PrimeWhite
    },
    focus: {
      backgroundColor: theme_Colors.Colors.PrimeWhite,
      borderColor: theme_Colors.Colors.PrimeWhite
    }
  }
};
const Indicator = ({ "aria-label": ariaLabel, color, count, noun = "page", onChangeIndex, selectedIndex }) => {
  const [name] = React.useState(utils_uniqueId.uniqueId("Indicator-"));
  const handleOnChange = ({ target }) => {
    const { value } = target;
    const index = parseInt(value, 10);
    onChangeIndex(index);
  };
  return React__default.default.createElement("div", { "aria-label": ariaLabel, className: styles.root, "data-zds": true, role: "radiogroup", style: {
    "--_zds-indicator-grid-template-columns": `repeat(${count}, 10px)`
  } }, Array.from({ length: count }, (_, i) => React__default.default.createElement("input", { "aria-label": `${noun} ${i + 1}`, checked: i === selectedIndex, className: styles.input, key: `bubble-${i}`, name, onChange: handleOnChange, style: {
    "--_zds-indicator-before-border-color": colorVariations[color].focus.backgroundColor,
    "--_zds-indicator-border-color": colorVariations[color].base.borderColor,
    "--_zds-indicator-border-color-checked": colorVariations[color].check.borderColor,
    "--_zds-indicator-border-color-focus": colorVariations[color].focus.borderColor,
    "--_zds-indicator-border-color-hover": colorVariations[color].hover.borderColor
  }, type: "radio", value: i, "data-zds": true })));
};

exports.Indicator = Indicator;
//# sourceMappingURL=Indicator.cjs.js.map
